import React from "react";
import { BackgroundImage,ServiceCard, AppointmentComponent, HomeAppointment, WhatCustomerSays, Faq } from "../../ThirdComponents";

const ThirdService = (props) => {
    const { selectedLanguage } = props
    return (
        <div>
            <BackgroundImage {...props} heading={selectedLanguage?.service_heading} mainClass='third-design-service-banner' />
            <ServiceCard {...props}/>
            <AppointmentComponent {...props}/>
            <HomeAppointment {...props}/>
            <WhatCustomerSays {...props}/>
            <Faq {...props}/>
        </div>
    )
}

export default ThirdService